import React, {useCallback, useContext, useEffect, useState} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import {useMenu} from '../../../hooks/useMenu';
import BodyContentView from '../../views/bodyContentView';
import MATrim20TN from './ma-trim20TN';
import MATrim4TN from './mA-trim4TN';

function MATrim20({onExit, initiallyDisableKeypress}) {
  const [isKeypressDisabled, setIsKeypressDisabled] = useState(initiallyDisableKeypress);
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {onComponent, selected} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  const onLeft = useCallback(() => {
    onComponent(<MATrim4TN />);
  }, []);

  const onRight = useCallback(() => {
    onComponent(<MATrim20TN />);
  }, []);

  useEffect(() => {
    if (!leftPress || isKeypressDisabled) return;

    onLeft();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress || isKeypressDisabled) return;
    onRight();
  }, [rightPress]);

  useEffect(() => {
    onUpdateCommands({onLeft, onRight});
  }, [onLeft, onRight]);

  useEffect(() => {
    if (!initiallyDisableKeypress) return;

    setTimeout(() => {
      setIsKeypressDisabled(false);
    }, 500);
  }, []);

  return (
    <BodyContentView
      title="20.0 mA Trim"
      left="Back"
      right="Continue"
      caption="If the observed output is not 4.0 mA, press &lt to re-enter the output. Otherwise, press &gt to start the 20 mA trim. The output will be set to 20.0 mA."
    />
  );
}

export default MATrim20;
